module.exports = __webpack_public_path__ + "img/google.41ff0a90.png";